import { axiosInstance } from '@App/providers';
import { AddressValue } from '@src/shared/types';

const transformAddressesFromRequest = (data: any) => {
    if (!data) return [];
    return data.map((item: any): AddressValue => {
        return {
            id: item.id,
            dependantThoroughfare: item.dependant_thoroughfare,
            streetName: item.thoroughfare,
            subBuildingName: item.sub_building_name,
            departmentName: item.department_name,
            buildingName: item.building_name,
            organisationName: item.organisation_name,
            buildingNumber: item.building_number,
            postcode: item.postcode,
            line1: item.line_1,
            line2: item.line_2,
            uprn: item.uprn,
            udprn: item.udprn,
            poBox: item.po_box,
            city: item.post_town,
            county: item.county,
            country: item.country,
        };
    });
};

export const getPostcodeLookupKey = (postcode?: string | null) =>
    postcode ? postcode.replace(/\s+/g, '').toUpperCase() : '';

const getPostcodeEndpoint = () => {
    const baseURL = 'https://ms-postcode-proxy.';
    const endpointSuffix = '/v1/postcodes';

    switch (window?._env_?.ENV?.toUpperCase()) {
        case 'PRODUCTION':
            return `${baseURL}selinafinance.co.uk${endpointSuffix}`;
        case 'UAT':
            return `${baseURL}uat.selinadev.co.uk${endpointSuffix}`;
        default:
            return `${baseURL}staging.selinadev.co.uk${endpointSuffix}`;
    }
};

export const getAddressesByPostcode = async (postcode: string) => {
    const postcodeKey = getPostcodeLookupKey(postcode);

    const result = await axiosInstance.get(
        `${getPostcodeEndpoint()}/${postcodeKey}`,
    );

    return transformAddressesFromRequest(result.data.result);
};
